<ng-container *ngIf="companies.length > 0">
  <app-list [dividers]="true" class="company-container">
    <app-list-item
      *ngFor="let company of companies"
      class="company-item"
      (clicked)="onChooseCompany(company.company)"
      [ngClass]="company.loggedIn ? 'logged-in' : 'logged-out'"
    >
      <ng-template #leading>
        <div class="company-first-letter">
          {{ company.company.name ? company.company.name[0] : '' }}
        </div>
      </ng-template>

      <span class="company-name">
        {{ company.company.name || '' }}
      </span>

      <ng-template #trailing>
        <app-button
          variant="ghost-primary"
          size="default-none"
          *ngIf="company.loggedIn; else loginButton"
        >
          Selecionar
          <app-icon *ngIf="company.loggedIn">arrow_forward</app-icon>
        </app-button>
        <ng-template #loginButton>
          <app-button>Entrar</app-button>
        </ng-template>
      </ng-template>
    </app-list-item>
  </app-list>
</ng-container>
